import { create } from 'zustand';
import api from '../api/axios';
import { logError } from '../utils/errorHandler';

/**
 * Cache transaksi bersama antara halaman Transaksi & Statistik.
 *
 * Key cache = `${book_id}|${start}|${end}` — data buku yang sama dengan
 * periode yang sama hanya di-fetch sekali, lalu dipakai ulang oleh
 * screen manapun. Statistik tidak perlu memanggil /statistics lagi
 * karena semua angkanya bisa diturunkan dari raw transaksi (lihat
 * utils/statistik.js).
 *
 * Wajib panggil invalidate(book_id) setiap kali ada perubahan data
 * (add/save/delete/import) agar cache tidak basi.
 */
export const useTransactionStore = create((set, get) => ({
    cache: {},
    loading: false,

    // Ambil transaksi: instant dari cache bila sudah ada, atau fetch ke API
    getTransactions: async (book_id, start, end) => {
        const key = `${book_id}|${start}|${end}`;

        const cached = get().cache[key];
        if (cached) {
            // salinan dangkal agar screen tidak mengubah isi cache
            return [...cached];
        }

        set({ loading: true });
        try {
            const res = await api.post('/transactions', {
                book_id: book_id,
                start_date: start,
                end_date: end
            });
            const transc = res.data.transactions || [];

            set((s) => ({
                cache: { ...s.cache, [key]: transc },
                loading: false
            }));
            return [...transc];
        } catch (error) {
            logError('Gagal memuat transaksi:', error);
            set({ loading: false });
            return [];
        }
    },

    // Kosongkan cache satu buku (atau semua buku bila book_id null)
    invalidate: (book_id = null) => {
        set((s) => {
            if (!book_id) {
                return { cache: {} };
            }
            const cache = { ...s.cache };
            Object.keys(cache).forEach((key) => {
                if (key.startsWith(book_id + '|')) {
                    delete cache[key];
                }
            });
            return { cache };
        });
    }
}));
